import BaseListPage from "../../../../base/BaseListPage";
import CustomFilterGenerator from "../../../../components/CustomFilterGenerator/CustomFilterGenerator";
import PageContainer from "../../../../components/PageContainer/PageContainer";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../utils/withRouter";
import AffiliateBranchesListPresenter from "./AffiliateBranchesListPresenter";

class AffiliateBranchesListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AffiliateBranchesListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase()
    );

    this.fieldsToDisplay = ["code", "clientCode", "name", "status"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "branches";
  }

  getActions() {
    return [
      {
        label: "Edit",
        onClick: this.onClickItem.bind(this),
        icon: "bi bi-pencil-square",
      },
    ];
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    return (
      <PageContainer
        title="Affiliate Branches"
        buttonHandler={this.onClickAdd.bind(this)}
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <CustomFilterGenerator
          schema={schema}
          onChangeFilter={this.onChangeFilter.bind(this)}
        />
        <Table
          fields={schema.fields}
          objects={objects}
          collapsable
          progress={loading}
          actions={this.getActions.bind(this)}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key)
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(AffiliateBranchesListPage);
